<div class="modifier-class js-tab-group">
    <nav class="tab-nav">
        <a id="text-tab-title" class="tab-title js-tab" (click)="activateTabByName('text')">Text</a>
        <a id="point-tab-title" class="tab-title js-tab" (click)="activateTabByName('point')">Point</a>
        <a id="line-tab-title" class="tab-title js-tab" (click)="activateTabByName('line')">Line</a>
        <a id="polygon-tab-title" class="tab-title js-tab" (click)="activateTabByName('polygon')">Polygon</a>
    </nav>
    <section class="tab-contents">
        <article class="tab-section js-tab-section">
            <mc-draw-text #textTab></mc-draw-text>
        </article>
        <article class="tab-section js-tab-section is-active">
            <mc-draw-point #pointTab (drawComplete)="onDrawComplete($event)"></mc-draw-point>
        </article>
        <article class="tab-section js-tab-section">
            <mc-draw-line #lineTab (drawComplete)="onDrawComplete($event)"></mc-draw-line>
        </article>
        <article class="tab-section js-tab-section">
            <mc-draw-polygon #polygonTab (drawComplete)="onDrawComplete($event)"></mc-draw-polygon>
        </article>
        <label class="toggle-switch clearfix right" *ngIf="enableBuffer">
            <span class="togggle-switch-label font-size--1 margin-right-half">Buffer Drawing:</span>
            <input type="checkbox" name="bufferDrawing" class="toggle-switch-input" [(ngModel)]="bufferDrawing">
            <span class="toggle-switch-track"></span>
        </label>
        <div [hidden]="!bufferDrawing || !enableBuffer" class="buffer-area">
            <mc-buffer #buffer [options]="bufferOptions"></mc-buffer>
        </div>
    </section>
</div>
